/*
 * Judge.me の星（Star Ratings＝プレビューバッジ）を押したら、下のレビュー帯まで移動させる。
 * アプリ側はこの動きを付けておらず、レビュー本体は display:contents で箱を持たない＝
 * 位置を測ると 0 になるため、移動先には帯そのもの（.reviews）を使う。
 * 移動はテーマのページ内リンクと同じ仕組み（reu-scroll.js）に任せる。
 */
(function () {
  var BADGE = '.jdgm-prev-badge';

  /* ─── 移動先＝レビュー本体を含む帯 ─── */
  function reviewSection() {
    var widget = document.querySelector('.jdgm-review-widget, .jm-review-widget');
    if (!widget) return null;
    return widget.closest('.reviews') || widget.closest('[id^="shopify-section"]');
  }

  // 浮遊ヘッダーの高さ分だけ手前で止める（ページ内リンクと同じ基準）
  function headerOffset() {
    return typeof getCSSVariablePixelValue === 'function' ? getCSSVariablePixelValue('--header-height') : 0;
  }

  function goToReviews(badge) {
    var target = reviewSection();
    if (!target || target.contains(badge)) return false; // 帯の中にある星は対象外
    if (typeof scrollToTarget === 'function') {
      scrollToTarget(target, headerOffset());
    } else {
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - headerOffset(),
        behavior: 'smooth'
      });
    }
    return true;
  }

  // 商品カード等、リンクの中に置かれた星は本来の遷移に任せる
  function isInsideLink(badge) {
    return badge.closest('a[href]') !== null;
  }

  /* ─── 星はアプリがページ表示のあとに差し込むため document で受ける ─── */
  // アプリが星の入れ物で click の伝播を止めており、通常の（浮かび上がる）受け方では届かない。
  // 先に降りてくる段階（capture）で受ける。アプリ側の処理は止めずそのまま通す。
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var badge = e.target.closest(BADGE);
    if (!badge || isInsideLink(badge)) return;
    if (goToReviews(badge)) e.preventDefault();
  }, true);

  // 星はキーボードでも選べる（role="button" tabindex="0"）
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = document.activeElement;
    if (!(el instanceof Element)) return;
    var badge = el.closest(BADGE);
    if (!badge || isInsideLink(badge)) return;
    if (goToReviews(badge)) e.preventDefault();
  }, true);
})();

/*
 * カルーセルのカードに、商品ページと同じ「性別・年代・肌タイプ」と投稿者名を足す。
 * 投稿者名は上のデータ書き換えで決めたもの（ニックネームか「匿名」）で、Judge.me の名前は使わない。
 * アプリのカードはこれらを出さないが、カードの元データ（reviews_for_carousel）には入っているので、
 * app-judgeme-data.js が控えたデータを使い、カードが描かれたら本文の下へ差し込む。
 */
(function () {
  var CARD = '.jdgm-cards-carousel .jdgm-carousel-item[data-review-id]';

  function buildMeta(review) {
    var meta = document.createElement('div');
    meta.className = 'jdgmCardMeta';

    var answers = (review.cf_answers || []).filter(function (a) { return a && a.question_title && a.value; });
    if (answers.length) {
      var dl = document.createElement('dl');
      answers.forEach(function (a) {
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = a.question_title;
        dd.textContent = a.value;
        row.append(dt, dd);
        dl.appendChild(row);
      });
      meta.appendChild(dl);
    }

    if (review.reu_display_name) {
      var name = document.createElement('p');
      name.textContent = review.reu_display_name;
      meta.appendChild(name);
    }

    return meta.childElementCount ? meta : null;
  }

  function decorate(card) {
    if (card.querySelector(':scope > .jdgmCardMeta')) return; // 複製されたカードは中身ごと写ってくる
    var review = reviews.get(card.getAttribute('data-review-id'));
    if (!review) return;
    var meta = buildMeta(review);
    if (meta) card.appendChild(meta);
  }

  function decorateAll() {
    document.querySelectorAll(CARD).forEach(decorate);
  }

  /* ─── カードの元データ：app-judgeme-data.js が head で控えている（このファイルより先にデータが届くことがあるため） ─── */
  var reviews = window.reuJudgemeReviews || new Map();
  function refresh() {
    decorateAll();
    watchCarousels();
  }
  document.addEventListener('reu:judgeme-reviews', refresh);

  /* ─── データより後に描かれたカード・ループ用に複製されたカード ─── */
  var observer = new MutationObserver(decorateAll);
  var watched = new WeakSet();
  function watchCarousels() {
    document.querySelectorAll('.jdgm-cards-carousel').forEach(function (carousel) {
      if (watched.has(carousel)) return;
      watched.add(carousel);
      observer.observe(carousel, { childList: true, subtree: true });
    });
  }

  if (reviews.size) refresh(); // このファイルより先に届いていた分
})();

/*
 * 投稿フォーム：表示名の欄を隠し、カスタム質問「ニックネーム」の回答を写す。
 * Judge.me の表示名は必須で、メールの依頼から来た人には注文者の本名が入るうえ、同じメールの過去レビューの名前まで上書きする。
 * サイトに出す名前はニックネームの回答だけにしているので（app-judgeme-data.js）、表示名にもニックネームか「匿名」を入れて揃える。
 * ニックネームの質問は表示名の画面より後にあるため、画面を進むたびと入力のたびに写し直し、送信時の値を最新にする。
 * 質問が見つからないとき（題名の変更など）は何もせず、表示名の欄はそのまま見える。
 */
(function () {
  if (!window.reviewNicknames) return; // ニックネーム差し替えを止めているあいだは何もしない（theme.liquid のスイッチ）
  var MODAL = '.jdgm-write-review-modal';
  var NICKNAME_QUESTION = 'ニックネーム';
  var NAME_MAX = 100; // Judge.me の表示名の上限

  function nicknameInput(modal) {
    var groups = modal.querySelectorAll('.jdgm-cf[data-type="text"]');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.jdgm-write-review-modal__field-label');
      if (label && label.textContent.trim() === NICKNAME_QUESTION) return groups[i].querySelector('input[type="text"]');
    }
    return null;
  }

  function sync(modal) {
    var nickname = nicknameInput(modal);
    var name = modal.querySelector('#jdgm-name-input');
    var anonymous = modal.querySelector('#jdgm-anonymous-checkbox');
    if (!nickname || !name) {
      modal.removeAttribute('data-reu-nickname');
      return;
    }
    var anonymousLabel = (window.jdgmSettings && window.jdgmSettings.widget_reviewer_anonymous) || '匿名';
    name.value = nickname.value.trim().slice(0, NAME_MAX) || anonymousLabel;
    if (anonymous && anonymous.checked) anonymous.click(); // 匿名はニックネームを空欄にすることで選ぶ
    modal.setAttribute('data-reu-nickname', '');
  }

  // 画面を進めるボタン：アプリの入力チェックより先に写すため、降りてくる段階（capture）で受ける
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var modal = e.target.closest(MODAL);
    if (modal) sync(modal);
  }, true);

  document.addEventListener('input', function (e) {
    if (!(e.target instanceof Element) || !e.target.matches('.jdgm-cf input[type="text"]')) return;
    var modal = e.target.closest(MODAL);
    if (modal) sync(modal);
  }, true);
})();
